import React from 'react'
import { Link } from 'react-router-dom'

import DateTimeUtil from '../DateTime'

import Title from '../../components/Datatable/Column.Title'
import DateTime from '../../components/Datatable/Column.DateTime'
import Status from '../../pages/posts/Column.Status'

import DatePicker from '../../pages/posts/Filter.DatePicker'

const COLUMNS = 
[
    {
        title: 'หัวเรื่อง',
        dataIndex: 'overview.title',
        width: 480,
    },

    {
        title: 'โครงการ',
        dataIndex: 'overview.author',
        width: 320,
        
        filterMultiple: false,
        filters:
        [
            
        ],
    },

    {
        title: 'ประเภท',
        dataIndex: 'overview.category',
        width: 80,
        
        filterMultiple: false,
        filters:
        [
            
        ],
    },

    {
        title: 'สถานะ',
        dataIndex: 'info.status',
        width: 100,
        render: e => (
            <div style={{ minWidth: 100 }} >
                <Status value={e} />
            </div>
        ),
        filterMultiple: false,
        filters:
        [
            {
                text: 'DRAFT',
                value: 'draft',
            },
            {
                text: 'PUBLISHED',
                value: 'published',
            },
            {
                text: 'CHANGED',
                value: 'changed',
            },
        ],
    },

    {
        title: 'วันที่สร้าง',
        dataIndex: 'info.createdAt',
        width: 104,
        render: e => (
            <div style={{ minWidth: 104 }} >
                <DateTime value={e} />
            </div>
        ),

        defaultSortOrder: 'descend',
        sorter: (a, b) => DateTimeUtil.compare(a.createdAt, b.createdAt),
        sortDirections: ['descend', 'ascend'],

        filterDropdown: DatePicker,
    },
]

function columns (
    {
        keyword,
        taxonomy,
    }
)
{
    const authors = {}
    const categories = {}

    taxonomy.authors.forEach(function (item) { authors[item.value] = item.text })
    taxonomy.categories.forEach(function (item) { categories[item.value] = item.text })

    const _columns = [ ...COLUMNS ]

    _columns[1].filters = taxonomy.authors
    _columns[2].filters = taxonomy.categories

    _columns[0].render = function (value, record)
    {
        return (
            <div style={{ minWidth: 220 }} >
                <Link to={`/posts/${record.id}`}>
                    <Title 
                        value={value}
                        keyword={keyword}
                    />
                </Link>
            </div>
        )
    }

    _columns[1].render = function (value)
    {
        return (
            <div style={{ minWidth: 200 }} >
                {authors[value]}
            </div>
        )
    }

    _columns[2].render = function (value)
    {
        return (
            <div style={{ minWidth: 80 }} >
                {categories[value]}
            </div>
        )
    }

    return _columns
}

export default
{
    columns,
}